import { memo, useMemo, useState } from "react";

import { ChevronUpDown } from "components/icons/generated";
import Icon from "ds/components/Icon";
import { pluralizeNext } from "shared/Pluralize";

import { collapseUnchangedLines } from "../helpers";
import type { RunCodeChangesTokenizedDiffLine } from "../types";
import RunCodeChangesJsonDiffLine from "./DiffLine";
import styles from "./styles.module.css";

type RunCodeChangesJsonDiffContentProps = {
  lines: RunCodeChangesTokenizedDiffLine[];
};

const RunCodeChangesJsonDiffContent = memo(({ lines }: RunCodeChangesJsonDiffContentProps) => {
  const chunks = useMemo(() => collapseUnchangedLines(lines), [lines]);
  const [expandedFolds, setExpandedFolds] = useState<Set<number>>(new Set());

  return (
    <div className={styles.contentWrapper}>
      <pre className={styles.content}>
        {chunks.map((chunk, i) => {
          if (!("count" in chunk)) {
            return <RunCodeChangesJsonDiffLine key={i} line={chunk} />;
          }

          if (expandedFolds.has(i)) {
            return chunk.lines.map((line, j) => (
              <RunCodeChangesJsonDiffLine key={`${i}-${j}`} line={line} />
            ));
          }

          return (
            <button
              key={i}
              type="button"
              className={styles.fold}
              onClick={() => setExpandedFolds((prev) => new Set(prev).add(i))}
            >
              <Icon src={ChevronUpDown} noShrink />
              {`Expand unchanged ${pluralizeNext(chunk.count, "line")}`}
            </button>
          );
        })}
      </pre>
    </div>
  );
});

RunCodeChangesJsonDiffContent.displayName = "RunCodeChangesJsonDiffContent";

export default RunCodeChangesJsonDiffContent;
